module.exports = __webpack_public_path__ + "img/Weapon_145.97d8d2db.png";